import React from 'react';
import PropTypes from 'prop-types';
import mark from '../../assets/img/bugzero/BZ_Logo_FNL_Icon_Full.png';

// BugZero brand mark (icon only). Renders the official logo icon asset.
const BugMark = ({ size = 22 }) => (
  <img src={mark} alt="BugZero" width={size} height={size} style={{ display: 'block', objectFit: 'contain' }} />
);

BugMark.propTypes = {
  size: PropTypes.number
};

export default BugMark;
